import { Component, Pipe, PipeTransform, Injectable, OnInit } from '@angular/core';
import { User } from "../../models/user";
import { Machine } from "../../models/machine";
import { UserService } from "../../services/user.service";
import { AlertService } from "../../services/alerts.service";
import { Alert } from "../../models/alert";
import { AlertPreference } from "../../models/alert-preference";
import { AccountService } from "../../services/account.service";
import { Router } from '@angular/router';


@Pipe({
    name: 'selected',
    pure: false
})

@Injectable()
export class SelectedPipe implements PipeTransform {
    transform(items: any[]): any {
        // filter items array, items which match and return true will be kept, false will be filtered out
        return items.filter(item => item.selected);
    }
}

@Component({
    selector: 'create-user',
    templateUrl: 'create-user.component.html',
    styleUrls: ['create-user.component.css'],
    moduleId: module.id
})
export class CreateUserComponent implements OnInit{
    activeStep: number;
    user: User;
    alerts: Alert[] = [];
    availableMachines: any[] = [];
    activeAlerts: AlertPreference[] = [];
    stepOneInvalid: boolean = false;
    stepOneInvalidMessage: string = "";
    stepTwoInvalid: boolean = false;
    stepThreeInvalid: boolean = false;
    constructor(
        private userService: UserService,
        private alertService: AlertService,
        private accountService: AccountService,
        private router: Router
    ) {}
    ngOnInit(): void {
        this.activeStep = 1;
        let user: User = new User();
        let me = this;
        this.user = user;
        this.alertService.getBaseAlerts().then(alerts => {
            this.alerts = alerts;

            alerts.forEach(alert => {
                let pref = new AlertPreference();
                pref.name = alert.name;
                pref.alertId = alert.id;
                pref.machineId = null;
                me.user.defaultAlertPreferences.push(pref);
            });

            me.user.alertsEnabled = true;

            me.activeAlerts = me.user.defaultAlertPreferences;

            me.accountService.machines().then(function(machines){
               for (let machine of machines) {
                   let availableMachine = {
                       id: machine.id,
                       name: machine.name,
                       serialNumber: machine.serialNumber,
                       //computed fields, just for this view
                       selected: false,
                       //role is Owner, Tech, Employee
                       role: "",
                       isOwner: false,
                       isEmployee: false,
                       isTech: false,
                       alerts: alerts
                   };
                   me.availableMachines.push(availableMachine);
               }
            });

        });
    }
    back(): void {
        this.activeStep--;
    }

    machineSelected(machineId: string) : void {
        if (machineId == "0") {
            //setting defaultAlerts
            this.activeAlerts = this.user.defaultAlertPreferences;
        } else {
            //do we have alerts for this machine yet?
            let existing: any = null;
            for (let prefs of this.user.alertPreferences) {
                if (prefs.machineId === machineId) {
                    existing = prefs;
                }
            }
            if (existing) {
                this.activeAlerts = existing;
            } else {
                this.activeAlerts = [];
                //initialize a new alert array
                this.alerts.forEach(alert => {
                    let pref = new AlertPreference();
                    pref.alertId = alert.id;
                    pref.machineId = machineId;
                    pref.name = alert.name;
                    this.activeAlerts.push(pref);
                    this.user.alertPreferences.push(pref);
                });
            }

        }

    }

    private async validateStepOne() {
        let complete = await this.userService.checkIfEmailExists(this.user.email);
        console.log("Complete response:" , complete);
        if (complete) {
            this.stepOneInvalidMessage = "Email exists already";
            return false;
        }
        if (!(this.user.firstName && this.user.lastName && this.user.email)) {
            this.stepOneInvalidMessage = "Name and Email are required";
            return false;
        }
        if (!this.user.password) {
            this.stepOneInvalidMessage = "Please enter a password";
            return false;
        }
        //TODO - this only works for US phone numbers. International support would need this to change
        if (this.user.phone) {
            let digits: string = this.user.phone.replace(/[^\d]/g,'');
            if(!digits || digits.length !== 10) {
                this.stepOneInvalidMessage = "Please enter a valid US phone number";
                return false;
            }
        }

        //let emailRe: RegExp = new RegExp(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/);
        //if (!emailRe.test(this.user.email)) {
        //    this.stepOneInvalidMessage = "Please enter a valid email address";
        //    return false;
        //}
        return true;
    }
    private validateStepTwo(): boolean {
        return this.availableMachines.filter(item => item.selected).length > 0;
    }
    private validateStepThree(): boolean {
        let selected: any[] = this.availableMachines.filter(item => item.selected);
        for (let machine of selected) {
            if (!machine.role) {
                return false;
            }
        }
        return true;
    }
    async forward(){
        let valid: boolean = false;
        if (this.activeStep === 1) {
            let valid = await this.validateStepOne();
            if (!valid) {
                this.stepOneInvalid = true;
            } else {
                this.stepOneInvalid = false;
                this.activeStep++;
            }
        } else if(this.activeStep === 2) {
            valid = this.validateStepTwo();
            if (!valid) {
                this.stepTwoInvalid = true;
            } else {
                this.stepTwoInvalid = false;
                this.activeStep++;
            }
        } else if(this.activeStep === 3) {
            valid = this.validateStepThree();
            if (!valid) {
                this.stepThreeInvalid = true;
            } else {
                this.stepThreeInvalid = false;
                this.activeStep++;
            }
        }
    }

    getAddress(place: any): void {
        console.log("Got a Place back from google", place);
        let components: any = place.address_components;
        let streetNumber: string = "";
        let streetName: string = "";
        for (let component of components) {
            for (let t of component.types) {
                if (t === "route") {
                    streetName = component.long_name;
                }
                if (t === "street_number") {
                    streetNumber = component.long_name;
                }
                if (t === "locality") {
                    this.user.city = component.long_name;
                }
                if (t === "administrative_area_level_1") {
                    this.user.state = component.short_name;
                }
                if (t === "country") {
                    this.user.country = component.short_name;
                }
                if (t === "postal_code") {
                    this.user.zip = component.long_name;
                }
            }
        }
        this.user.street = `${streetNumber} ${streetName}`.trim();
        console.log("Mapped address to user", this.user);
    }

    save(): void {
        //need to map availableMachines to a real machine object
        let machines: Machine[] = [];
        for (let m of this.availableMachines) {
            if (m.selected) {
                //probably only need this to send to the db
                let machine: Machine = new Machine();
                machine.id = m.id;
                machine.role = m.role;
                this.user.assignedMachines.push(machine);
            }
        }
        this.userService.create(this.user).then(result => this.router.navigate(['users']));

    }
    selectAllMachines(checked: boolean): void {
        for (let m of this.availableMachines) {
            m.selected = checked;
        }
    }
    setRole(machine: any, role: string): void {

        machine.role = role;
        if (role === 'Owner') {
            machine.isTech = false;
            machine.isEmployee = false;
        }
        if (role === 'Tech') {
            machine.isOwner = false;
            machine.isEmployee = false;
        }
        if (role === 'Employee') {
            machine.isOwner = false;
            machine.isTech = false;
        }
    }
    selectAll(alert: AlertPreference): void {
        alert.allSelected = !alert.allSelected;
        if (alert.allSelected) {
            alert.email = true;
            //alert.pushNotification = true;
            alert.textMessage = true;
        } else {
            alert.email = false;
            //alert.pushNotification = false;
            alert.textMessage = false;
        }

    }

    alertChanged(checked: boolean, alertPref: AlertPreference): void {
        if (!checked && alertPref.allSelected) {
            alertPref.allSelected = false;
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/components/create-user/create-user.component.ts